import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { UserType } from 'domain/types';
import { useComponent } from 'hooks';
import { useBank } from 'tanstack-hooks/fi-bank/queries/useBank';
import { useUser } from 'tanstack-hooks/user/queries/useUser';
import { userHasRole } from 'ui/routing/router-util';
import { useFiWebsockets } from '../apps/fi/util';
import { Spinner } from '../atoms';

export const FiRoute: React.FC<{ path: string }> = useComponent(({ path }) => {
  let userHasRoles = false;

  const { user } = useUser();
  const { bank } = useBank();

  useFiWebsockets();

  //check user role
  if (user?.id && bank?.groups) {
    userHasRoles = userHasRole(bank?.groups, user, path);
  }

  return user?.type === UserType.Bank && userHasRoles ? (
    <Outlet />
  ) : !user?.id || !bank?.id ? (
    <Spinner text="Loading business information..." />
  ) : !userHasRoles ? (
    <Navigate to={{ pathname: '/error' }} />
  ) : (
    <Navigate to={{ pathname: '/' }} />
  );
});
